import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ActiviteitPage} from '../activiteit-page';
import {Activiteit, VerwerkingsStatus} from '../activiteit';
import {Zone} from '../../zone/zone';
import {ActiviteitPageRequest} from '../activiteit-page-request';
import {MatSelectChange} from '@angular/material/select';
import {SortOrder} from '../../core/sort/sort-order';
import {PageRequest} from '../../core/pagination/page-request';
import {Dienst} from '../../dienst/dienst';

@Component({
    selector: 'zah-activiteiten-navigatie',
    templateUrl: './activiteiten-navigatie.component.html',
    styleUrls: ['./activiteiten-navigatie.component.scss'],
    standalone: false
})
export class ActiviteitenNavigatieComponent implements OnInit, OnChanges {

  @Input()
  initialPageRequest: ActiviteitPageRequest;
  @Input()
  activiteitenPage: ActiviteitPage;
  @Input()
  zones: Array<Zone>;
  @Input()
  diensten: Array<Dienst>;
  @Output()
  activiteitSelected: EventEmitter<Activiteit> = new EventEmitter<Activiteit>();
  @Output()
  pageChange: EventEmitter<ActiviteitPageRequest> = new EventEmitter<ActiviteitPageRequest>();

  selectedZones: string[];
  selectedDiensten: string[];

  openStatus: VerwerkingsStatus;
  selectedActiviteit: Activiteit;

  currentPageRequest: ActiviteitPageRequest;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const newPage: ActiviteitPage = changes.activiteitenPage.currentValue;
    this.openStatus = newPage.getVerwerkingsStatus();
    if (!newPage?.isEmpty()) {
      this.selectActiviteit(newPage.getFirstItemOnPage());
    }
  }

  changeZone(change: MatSelectChange): void {
    this.selectedZones = change.value;
    this.sendPageRequest(this.selectedZones, this.selectedDiensten);
  }

  changeDienst(change: MatSelectChange): void {
    this.selectedDiensten = change.value;
    this.sendPageRequest(this.selectedZones, this.selectedDiensten);
  }

  sendPageRequest(zones, diensten): void{
    if (zones && zones.length === 0){zones = undefined; }
    if (diensten && diensten.length === 0){diensten = undefined; }
    const pageRequest = this.currentPageRequest.withZoneIdAndDienstId(zones, diensten);
    this.changePage(pageRequest);
  }

  isTeVerwerkenOpen(): boolean {
    return this.openStatus === VerwerkingsStatus.OPEN;
  }

  toggleTeVerwerken(): void {
    if (this.isTeVerwerkenOpen()) {
      this.closeVerwerkingsStatus();
    } else {
      this.openVerwerkingsStatus(VerwerkingsStatus.OPEN);
    }
  }

  isGeschiedenisOpen(): boolean {
    return this.openStatus === VerwerkingsStatus.VERWERKT;
  }

  toggleGeschiedenis(): void {
    if (this.isGeschiedenisOpen()) {
      this.closeVerwerkingsStatus();
    } else {
      this.openVerwerkingsStatus(VerwerkingsStatus.VERWERKT);
    }
  }

  getActiviteitId(index: number, activiteit: Activiteit): string {
    return activiteit.getId();
  }

  selectActiviteit(activiteit: Activiteit): void {
    this.selectedActiviteit = activiteit;
    this.activiteitSelected.emit(this.selectedActiviteit);
  }

  onPageSizeChange(pageSize: number): void {
    const pageRequest = this.currentPageRequest.withPageSize(pageSize);
    this.changePage(pageRequest);
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    const pageRequest = this.currentPageRequest.withSortOrder(sortOrder);
    this.changePage(pageRequest);
  }

  onPageChange(pageRequest: PageRequest<Activiteit>): void {
    const activiteitPageRequest = this.currentPageRequest.forPageRequest(pageRequest);
    this.changePage(activiteitPageRequest);
  }

  private closeVerwerkingsStatus(): void {
    this.activiteitenPage = null;
    this.openStatus = null;
    this.selectedActiviteit = null;
  }

  private openVerwerkingsStatus(verwerkingsStatus: VerwerkingsStatus): void {
    this.openStatus = verwerkingsStatus;
    const pageRequest = this.currentPageRequest.withVerwerkingsStatus(
      verwerkingsStatus,
      verwerkingsStatus === VerwerkingsStatus.OPEN ? SortOrder.ASCENDING : SortOrder.DESCENDING);
    this.changePage(pageRequest);
  }

  private changePage(pageRequest: ActiviteitPageRequest): void {
    this.activiteitenPage = null;
    this.selectedActiviteit = null;
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(this.currentPageRequest);
  }
}
